import React from 'react'
import TextFieldIcon from '@material-ui/icons/TextFields'
import {IconButton, Tooltip} from '@material-ui/core';
import {connect} from 'react-redux'
import {setLargeText} from 'redux/actions'
import Tr from 'translations/Translations';

function TextSizeButton(
	{
		largeText,
		setLargeText
	}) {

	const handleClick = () => {
		setLargeText(!largeText);
	}

	return (
		<Tooltip title={Tr('larger_letters')}>
			<IconButton onClick={handleClick}>
				<TextFieldIcon/>
			</IconButton>
		</Tooltip>
	)
}

export default connect((state) => ({
	largeText: state.store.largeText
}), {
	setLargeText
})(TextSizeButton);
